import _         from 'lodash'
import pluralize from 'pluralize'
import Backend   from 'alto-utils/lib/backend'

ValidMatchers = ['in', 'any', 'all', 'icontains', 'contains', 'startswith', 'istartswith',
                 'endswith', 'iendswith', 'year', 'month', 'day', 'week_day', 'regex', 'range',
                 'gt', 'lt', 'gte', 'lte', 'isnull', 'eq']

export default class RequestBuilder
  constructor: (@baseUrl, @route, @auth, @model, @associations, @includes, @orders,
                @pageNumber, @pageSize, @logRequests) ->

  @for: (relation) ->
    params = _.at(relation,
                  'baseUrl', 'route', 'auth', 'model', 'associations', 'includes', 'orders',
                  'pageNumber', 'pageSize', 'logRequests')

    new @(params...)

  index: ->
    @_ajax('GET', '', params: _.concat(@_orderParams(), @_pageParams(), @_includeParams()))

  filteredIndex: (conditions) ->
    params = _.concat(@_condsToParams(conditions), @_orderParams(), \
                      @_pageParams(), @_includeParams())

    @_ajax('GET', '', { params })

  get: (pk) ->
    @_ajax('GET', '/' + pk, params: @_includeParams())

  post: (entity) ->
    @_ajax('POST', '', body: @model.serialize(entity))

  put: (pk, attributes) ->
    @_ajax('PUT', '/' + pk, body: @model.serialize(attributes))

  patch: (pk, attributes) ->
    @_ajax('PATCH', '/' + pk, body: @model.serialize(attributes))

  delete: (pk) ->
    @_ajax('DELETE', '/' + pk)

  postMany: (entities) ->
    @_ajax('POST', '', body: entities.map(@model.serialize.bind(@model)))

  _includeParams: ->
    @includes.map (frontendPath) =>
      ['include[]', @associations.backendPathFor(@model, frontendPath) + '.*']

  _orderParams: ->
    @orders.map (ordering) => ['sort[]', @_orderParamFor(ordering)]

  _condsToParams: (conditions) ->
    pairLists = _.flatMap _.toPairs(conditions), ([key, val]) =>
      if _.isArray val
        val.map (v) => ["filter{#{@_filterKeyFor(key)}}", v]
      else
        [["filter{#{@_filterKeyFor(key)}}", val]]

  _pageParams: ->
    [['page', @pageNumber], ['page_size', @pageSize]]

  _orderParamFor: (ordering) ->
    if _.startsWith(ordering, '-')
      direction = '-'
      ordering  = ordering.slice(1)
    else
      direction = ''

    [associations..., attr] = ordering.split('.')

    if associations.length
      assocPath   = associations.join('.')
      backendPath = @_backendNestedFieldPathFor(assocPath, attr)
    else
      backendPath = @model.backendNameFor(attr)

    direction + backendPath

  _filterKeyFor: (conditionKey) ->
    parts = _.split(conditionKey, /(\.|\|)/)

    if _.startsWith(parts[0], '-')
      parts[0] = parts[0].slice(1)
      sign     = '-'
    else
      sign     = ''

    if _.last(parts) in ValidMatchers
      [associations..., assocSep, attr, matcherSep, matcher] = parts

      if associations.length
        backendPath = @_backendNestedFieldPathFor(associations.join(''), assocSep, attr)
      else
        [attr, matcherSep, matcher] = parts

        backendPath = @model.backendNameFor(attr)

      [sign, backendPath, matcherSep, matcher].join('')

    else # without matcher
      [associations..., sep, attr] = parts

      if associations.length
        sign + @_backendNestedFieldPathFor(associations.join(''), sep, attr)
      else
        [attr] = parts

        sign + @model.backendNameFor(attr)

  _backendNestedFieldPathFor: (assocPath, sep, attr) ->
    backendAssocPath = @associations.backendPathFor(@model, assocPath)
    finalModel       = @associations.finalModelFor(@model, assocPath)
    backendAttrName  = finalModel.backendNameFor(attr)

    [backendAssocPath, backendAttrName].join(sep)

  _ajax: (method, path, { body = null, params = [] } = {}) ->
    throw new Error("you must log in to make request with auth") if @auth and not @auth.isLoggedIn

    url          = Backend.withParams("#{@baseUrl}#{@route}#{path}", params)
    options      = {}
    options.body = body if body

    if @auth
      Backend.requestWithAuth(@auth.token, method, url, options, @model.name, @logRequests)
    else
      Backend.request(method, url, options, @model.name, @logRequests)
